import { Suspense, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useScroll } from "@react-three/drei";

export default function Floor() {
  const scroll = useScroll();
  const ref = useRef();
  const refMesh = useRef();

  useFrame((state, delta) => {
    // [설정/바닥] 스크롤 기준 시작점 설정
    const t = scroll.offset;
    ref.current.opacity = Math.min(0.5, 1 - Math.max(0, t - 0.1) * 5);

    if (t > 0.55) refMesh.current.position.y = -100;
    else refMesh.current.position.y = -9;
  });

  return (
    <mesh
      ref={refMesh}
      scale={80}
      position={[0, -9, -12]}
      rotation={[-Math.PI * 0.5, 0, 0]}
    >
      <circleGeometry args={[1, 32]} />
      <meshBasicMaterial ref={ref} transparent={true} opacity={0.9} />
    </mesh>
  );
}
